import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

interface PendingOrdersToggleProps {
    showPendingOnly: boolean;
    onToggle: (value: boolean) => void;
    pendingCount: number;
    totalCount: number;
}

export function PendingOrdersToggle({
    showPendingOnly,
    onToggle,
    pendingCount,
    totalCount
}: PendingOrdersToggleProps) {
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            onToggle(!showPendingOnly);
        }
    };

    return (
        <div
            className="flex items-center gap-3 h-12 px-4 border border-border rounded-md bg-background hover:bg-muted transition-colors duration-200"
            role="group"
            aria-label="Order filter toggle"
        >
            <Switch
                id="pending-orders-toggle"
                checked={showPendingOnly}
                onCheckedChange={onToggle}
                onKeyDown={handleKeyDown}
                aria-label={`Show ${showPendingOnly ? 'pending' : 'all'} orders. Currently showing ${showPendingOnly ? pendingCount : totalCount} orders.`}
                className="data-[state=checked]:bg-action-primary"
            />
            <Label
                htmlFor="pending-orders-toggle"
                className="flex h-full flex-1 cursor-pointer select-none items-center gap-2 text-sm font-medium text-foreground"
            >
                <span>
                    Pending
                </span>
                <span className="text-xs font-normal text-muted-foreground tabular-nums">
                    ({showPendingOnly ? pendingCount : totalCount})
                </span>
            </Label>
        </div>
    );
}
